import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import PriceTable from "./PriceTable";

import {
  returnOpenWidgetsObject,
  updateOpenWidgetsWithPriceConfigs,
} from "@/lib/widgetHelperFunctions";
import bondSecuritiesStore from "@/store/bondSecuritiesStore";
import {
  getPricesFromBondSecuritiesAndAddToStore,
  setPriceRowsFromBondSecurities,
} from "@/store/priceDataStoreACTIONS";
import priceTabStore from "@/store/pricesTabStore";
import { useAuth0 } from "@auth0/auth0-react";

interface IPriceIndex {
  cryptoID?: string | undefined;
}

const PriceIndex = ({ cryptoID }: IPriceIndex) => {
  // const [toolbarIsOpen, setToolbarIsOpen] = useState(true);
  const { theme } = useTheme();

  // LQC-2575 - rows come from the same bond reference data the Leg Creation
  // widget loads, so whichever mounts first pays for GET /Securities/bonds.
  const bondSecurities = bondSecuritiesStore((state) => state.bondSecurities);

  const settingsConfigsFromStore = priceTabStore(
    (state) => state.priceConfigTabs,
  );

  const openWidgetObject = returnOpenWidgetsObject(cryptoID);

  const [activePricesConfigIdNumber, setActivePricesConfigIdNumber] =
    useState<number>(-1);

  // use a hook to prevent the activePricesConfigIdNumber dependency arr trigger on first load.
  const [firstLoadDone, setFirstLoadDone] = useState(false);

  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    if (openWidgetObject && openWidgetObject.activePricesConfigIdNumber) {
      setActivePricesConfigIdNumber(
        openWidgetObject.activePricesConfigIdNumber,
      );
    } else {
      setActivePricesConfigIdNumber(-1);
    }
    setFirstLoadDone(true);

    getPricesFromBondSecuritiesAndAddToStore(getAccessTokenSilently);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // A second Prices widget finds the securities already loaded, so re-seed off the
  // store rather than relying on its own fetch resolving.
  useEffect(() => {
    if (bondSecurities.length > 0) {
      setPriceRowsFromBondSecurities(bondSecurities);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bondSecurities]);

  useEffect(() => {
    // Once the active price tab is changed - Save it to the stateJson of the widget.
    if (firstLoadDone) {
      // condition gives widget time to set activeTab first.

      updateOpenWidgetsWithPriceConfigs({
        cryptoID,
        activePricesConfigIdNumber,
        getAccessTokenSilently,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePricesConfigIdNumber]);

  useEffect(() => {
    // if another widget deletes a config that the current widget is set to, set current widget to -1
    if (settingsConfigsFromStore.length > 0) {
      if (
        !settingsConfigsFromStore.find(
          (config) => config.id == activePricesConfigIdNumber,
        )
      ) {
        setActivePricesConfigIdNumber(-1);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settingsConfigsFromStore]);

  return (
    <div className="flex h-full w-full flex-auto">
      {settingsConfigsFromStore.length == 0 ? (
        <div className="flex h-full w-full flex-col items-center justify-center">
          <div className="">Loading views</div>
          <div className="loader"></div>
        </div>
      ) : (
        <PriceTable
          activePricesConfigIdNumber={activePricesConfigIdNumber}
          getAccessTokenSilently={getAccessTokenSilently}
          cryptoID={cryptoID}
          settingsConfigsFromStore={settingsConfigsFromStore}
          theme={theme}
          setActivePricesConfigIdNumber={setActivePricesConfigIdNumber}
          // settingsConfigsFromStoreInHook={settingsConfigsFromStoreInHook}
        />
      )}
    </div>
  );
};

export default PriceIndex;
